import BaseAPI from './BaseAPI'

export default class MetadataAPI extends BaseAPI {
  /**
   * POST /metadata/:id
   * @param  {string}  id
   * @param  {Object}  data
   * @param  {string}  organizationId
   * @return {Promise.<void, Error>} A promise with no data
   */
  async update(id: string, data: Object, organizationId: string) {
    await this.httpClient.post('/v2/metadata/:id', {
      urlParams: { id },
      data: data,
      headers: { 'TT-X-Organization-Key': organizationId }
    })
  }

  /**
   * GET /metadata/:id
   * @param  {string}  id
   * @param  {Object}  data
   * @param  {string}  organizationId
   * @return {Promise.<void, Error>} A promise with the metadata
   */
  async find(id: string, organizationId: string) {
    const res = await this.httpClient.get('/v2/metadata/:id', {
      urlParams: { id },
      headers: { 'TT-X-Organization-Key': organizationId }
    })

    return res.data
  }
}
